export default __webpack_public_path__ + "static/media/x-icon.a058c342.svg";